enum ProductOrderStatusType {
  PAYMENT_WAITING = 'PAYMENT_WAITING',
  CANCELED_BY_NOPAYMENT = 'CANCELED_BY_NOPAYMENT',
  PAYED = 'PAYED',
  DELIVERING = 'DELIVERING',
  DELIVERED = 'DELIVERED',
  PURCHASE_DECIDED = 'PURCHASE_DECIDED',
  CANCELED = 'CANCELED',
  RETURNED = 'RETURNED',
  EXCHANGED = 'EXCHANGED',
}

namespace ProductOrderStatusType {
  const values = {
    PAYMENT_WAITING: {
      name: '입금대기',
      reviewWritable: false,
    },
    CANCELED_BY_NOPAYMENT: {
      name: '미입금취소',
      reviewWritable: false,
    },
    PAYED: {
      name: '결제완료',
      reviewWritable: false,
    },
    DELIVERING: {
      name: '배송중',
      reviewWritable: false,
    },
    DELIVERED: {
      name: '배송완료',
      reviewWritable: false,
    },
    PURCHASE_DECIDED: {
      name: '구매확정',
      reviewWritable: true,
    },
    CANCELED: {
      name: '취소',
      reviewWritable: false,
    },
    RETURNED: {
      name: '반품',
      reviewWritable: false,
    },
    EXCHANGED: {
      name: '교환',
      reviewWritable: true,
    },
  }

  export const getName = (type: ProductOrderStatusType): string => {
    return values[type] && values[type].name
  }

  export const isReviewWritable = (type: ProductOrderStatusType): boolean => {
    return values[type] && values[type].reviewWritable
  }
}

export default ProductOrderStatusType
